import { createContext } from 'react';

const projectSpeedDialContext = createContext();

export default projectSpeedDialContext